import { CalendarView } from '@app/components/Calendars/components';
import type { NCalendars } from '@app/components/Calendars/types';
import { useWeeklyCalendar } from '@app/components/Calendars/WeeklyCalendar/hooks';

export const WeeklyCalendar: NCalendars.WeeklyCalendarType = () => {
  const {
    toPrevWeek,
    toNextWeek,
    dayNumbers,
    tasks,
    createTaskForRange,
    openPreviewTaskModal,
    isLoading,
  } = useWeeklyCalendar();
  return (
    <CalendarView
      type="weekly"
      dayHumbers={dayNumbers}
      toPrevDate={toPrevWeek}
      toNextDate={toNextWeek}
      tasks={tasks}
      createTaskForRange={createTaskForRange}
      openPreviewTaskModal={openPreviewTaskModal}
      isLoading={isLoading}
      className="weekly-calendar"
    />
  );
};
